<template>
  <!-- <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />

        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        />
      </div>

      <v-spacer></v-spacer>

      <v-btn
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
        text
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <HelloWorld/>
    </v-content>
  </v-app> -->

  <!-- <div id="app">
    <router-view></router-view>
  </div> -->

<v-app :dark="true" id="app">
  <router-view></router-view>
</v-app>    

</template>

<script>
import axios from 'axios'

import HelloWorld from './components/HelloWorld';


export default {
  name: 'App',

  components: {
    HelloWorld,
  },

  created () {

    axios.interceptors.request.use( (config) => {
      // Do something before request is sent

      // Add authorization token from localstorage to each api request  
      config.headers.authorization = 'Bearer ' + localStorage.getItem("token") 

      // Show progress spinner
      this.$store.commit('SET_LOADER', true)

      return config
    }, (error) => {
      // Do something with request error
      this.$store.commit('SET_LOADER', false)
      return Promise.reject(error)
    })

    axios.interceptors.response.use( (response) => {
      // Do something before response is returned
      this.$store.commit('SET_LOADER', false)
      return response
    }, (error) => {
        this.$store.commit('SET_LOADER', false)
        throw error
    })
    
  },  

  data: () => ({
    //
  }),
};
</script>

<style>
/* Imports an external CSS file */
@import './assets/styles/main.css';
</style>